<template>
  <div :class="componentClassName">
    <a-page-heading>連絡先</a-page-heading>
    <a-select-field
      v-if="companyID === POINT && companyIDList.length !== 0"
      id="companyIDList"
      v-model="selectedCompanyID"
      :options="companyIDList"
      :searchable="true"
    />
    <div class="t-phone-book-list__content">
      <div class="t-phone-book-list__filters">
        <div class="t-phone-book-list__search">
          <a-select-field
            id="searchType"
            v-model="searchForm.type"
            :options="searchTypeOptions"
            @change="handleChange"
          />
          <span class="t-phone-book-list__search-separator" />
          <a-text-field
            id="searchFilter"
            v-model="searchFilter"
            type="search"
            placeholder="検索"
            maxlength="50"
            @keypress.enter.stop="handleSearchInput"
          />
        </div>
        <div class="t-phone-book-list__filter-actions">
          <a-button
            v-show="viewAddBtn"
            v-if="canAdd"
            id="addButton"
            class="t-phone-book-list__add-button"
            icon="plus"
            icon-color="white"
            size="small"
            variant="fill"
            color="primary"
            label="新規登録"
            :inline="true"
            @click="handleAddUserClick"
          />
          <a-button
            v-show="viewBtn"
            v-if="canUpload"
            id="batchAddButton"
            class="t-phone-book-list__upload-button"
            icon="upload"
            icon-color="white"
            size="small"
            variant="fill"
            color="primary"
            label="一括登録"
            :inline="true"
            @click="handleBulkAddUserClick"
          />
          <a-button
            v-show="viewBtn"
            v-if="canUpload"
            id="all-delete"
            class="t-phone-book-list__upload-button"
            icon="upload"
            icon-color="white"
            size="small"
            variant="fill"
            color="primary"
            label="一括削除"
            :inline="true"
            @click="handleBulkDelUserClick"
          />
          <a-button
            v-show="viewBtn"
            v-if="canDownload"
            id="downloadButton"
            class="t-phone-book-list__download-button"
            icon="download"
            icon-color="white"
            size="small"
            variant="fill"
            color="primary"
            label="ダウンロード"
            :inline="true"
            @click="handleDownloadClick"
          />
        </div>
      </div>
      <div class="t-phone-book-list__summary">
        <m-contact-summary-bar id="summaryBar" :contact-list="contactSummaryList" @click="handleSummaryItem" />
      </div>
      <m-card-list id="listAll" ref="cardList" class="t-phone-book-list__list">
        <template v-for="(object, userID) in dispContactList" :key="userID">
          <a-list-item
            :id="object.id ? object.id.toString() : ''"
            size="small"
            :label="object.name.replace(`_`, ` `)"
            :sublabel="object.sublabel"
            :star="object.is_stared"
            @click="handleItemClick(userID)"
          />
        </template>
        <template v-if="Object.keys(contactList).length == 0">
          <a-text id="rowEmpty" :text="emptyText"> </a-text>
        </template>
      </m-card-list>
    </div>
  </div>
  <teleport to="body">
    <o-modal
      id="phoneBookList_removeModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="dialogOkButton"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import ACheckbox from '@/components/atoms/checkbox';
import AButton from '@/components/atoms/button';
import ATextField from '@/components/atoms/text-field';
import MCardList from '@/components/molecules/card-list';
import MListGroup from '@/components/molecules/list-group';
import AListItem from '@/components/atoms/list-item';
import MContactSummaryBar from '@/components/molecules/contact-summary-bar';

import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { PERMISSIONS_FRONTEND } from '@/libs/constants';
import { POINT } from '@/libs/constants';
// #2121
import { customValidate } from '@/common/customValidate.js';

export default {
  name: 't-phone-book-list', // #2121
  components: {
    APageHeading,
    ATextField,
    MCardList,
    AListItem,
    MContactSummaryBar,
    AButton,
  },
  mixins: [messageContent, customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    handleSearchInputChange: {
      type: Function,
      default: () => {},
    },
    handleOnlyFrequentlyUsedContractChange: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchFilter: '',
      onlyFrequentlyUsedContract: false,
      selectedCompanyID: '',
      contactSummaryList: [
        {
          key: 'a-row',
          label: 'あ行',
          active: true,
        },
        {
          key: 'ka-row',
          label: 'か行',
          active: true,
        },
        {
          key: 'sa-row',
          label: 'さ行',
          active: true,
        },
        {
          key: 'ta-row',
          label: 'た行',
          active: true,
        },
        {
          key: 'na-row',
          label: 'な行',
          active: true,
        },
        {
          key: 'ha-row',
          label: 'は行',
          active: true,
        },
        {
          key: 'ma-row',
          label: 'ま行',
          active: true,
        },
        {
          key: 'ya-row',
          label: 'や行',
          active: true,
        },
        {
          key: 'ra-row',
          label: 'ら行',
          active: true,
        },
        {
          key: 'wa-row',
          label: 'わ行',
          active: true,
        },
        {
          key: 'a-z-row',
          label: 'A~Z',
          active: true,
        },
      ],
      contactList: {},
      dispContactList: {}, // #2285
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      viewBtn: true,
      viewAddBtn: true,
      authInfo: this.$store.state.user.authInfo,
      // #2121
      searchTypeOptions: [
        {
          value: 'name',
          label: '名前',
        },
        {
          // #2362
          value: 'nameKana',
          label: 'フリガナ(名前)',
        },
        {
          // #2362
          value: 'documentID',
          label: '電話番号',
        },
        {
          value: 'mail',
          label: 'メールアドレス',
        },
        {
          value: 'companyName',
          label: '会社名',
        },
        {
          value: 'departmentName',
          label: '部署名',
        },
        {
          value: 'address',
          label: '住所',
        },
        {
          value: 'memo',
          label: 'メモ',
        },
      ],
      searchForm: {
        type: 'name',
        term: '',
        periods: null,
      },
      emptyText: '',
      messageEmptyText: messageContent.alertMessageEmptyText(),
      companyIDList: [],
      POINT,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-phone-book-list');
      return `${baseClassName} ${this.class}`.trim();
    },
    canAdd() {
      // 管理者権限(マスタ含)または003300以外の企業のオペレータの場合は新規登録可能
      return (
        PERMISSIONS_FRONTEND['phoneDataEditing'][this.authInfo] ||
        (this.companyID !== POINT && this.authInfo === 'operator')
      );
    },
    canUpload() {
      // 003300以外の管理者権限(マスタ含)の場合はアップロード可能
      return this.companyID !== POINT && PERMISSIONS_FRONTEND['phoneDataEditing'][this.authInfo];
    },
    canDownload() {
      // 003300以外の管理者権限(マスタ含)の場合はダウンロード可能
      return this.companyID !== POINT && PERMISSIONS_FRONTEND['phoneDataEditing'][this.authInfo];
    },
  },
  watch: {
    selectedCompanyID: async function (newValue, oldValue) {
      if (
        (this.companyID === POINT && newValue !== POINT && this.authInfo === 'soOperator') ||
        (this.companyID !== POINT && newValue !== this.companyID)
      ) {
        // 権限がない(003300のSOオペレータ, または003300以外の企業)の場合、他の企業IDは閲覧不可
        this.$router.push({ path: '/permission-denied' });
      } else {
        if (this.companyID === POINT && this.selectedCompanyID !== this.$route.query.companyID) {
          await this.$router.push({ query: { companyID: this.selectedCompanyID } });
          this.fetchContactListHandlerEx('', this.oldWordFlag); // #2285
          window.scrollTo(0, 0);
        }
        if (!newValue) {
          this.selectedCompanyID = oldValue;
        }
      }
    },
  },
  /**
   * #2121 #2285 新規登録や連絡先参照・更新から復帰してきた場合の表示の変更
   * this.$route.query.wordFlag - 表示させる行のインデックス '1'-あ行 '2'-か行...etc
   *   undef/''の場合は'0'(値が存在する最初の行)
   * this.$route.query.searchFormType - 選択項目の値 'name' - 名前 'companyName' - 会社名...etc
   *   undef/''の場合は'name'(名前)
   */
  created() {
    if (this.companyID === POINT && PERMISSIONS_FRONTEND['otherPhoneListReading'][this.authInfo]) {
      // 003300でSOオペレータ以外は他企業の連絡帳も閲覧可能
      this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : POINT;
      this.fetchCompanyIDListHandler();
    } else if (this.companyID !== POINT) {
      this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : '';
    }
    this.getUserAuth();
    // #2121 #2285
    // console.log("### Phone-Book-List created wordFlag-parameter="+this.$route.query.wordFlag);
    this.emptyText = '';
    this.oldWordFlag = this.$route.query.wordFlag ? this.$route.query.wordFlag : '0';
    if (this.oldWordFlag === '') {
      this.oldWordFlag = '0';
    }
    this.searchForm.type = this.$route.query.searchFormType ? this.$route.query.searchFormType : 'name';
    if (this.searchForm.type === '') {
      this.searchForm.type = 'name';
    }
    this.fetchContactListHandlerEx('', this.oldWordFlag); // #2285
    window.scrollTo(0, 0);
  },
  mounted() {
    if (this.companyID === POINT && this.authInfo === 'soOperator') {
      this.$router.push({ path: '/permission-denied' });
    }
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlistCCCOnly', { withPoint: true })
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('企業一覧の取得'));
        });
    },
    /**
     * handleSearchInput ENTERキー押下時のキーワード検索処理
     */
    handleSearchInput() {
      if (this.hasSpecialCharacterInObject({ keyWord: this.searchFilter })) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }
      // #2121 検索キーワードが空の場合には連絡先全ての一覧表示となる
      this.oldWordFlag = '0'; // キーワード検索時には行選択をクリアする
      this.fetchContactListHandlerEx(this.searchFilter.replace(/\t/g, '').replace(/[ 　]+/g, '_'), '0');
    },
    handleFlagChange(e) {
      this.handleOnlyFrequentlyUsedContractChange(e.target.checked);
    },
    fetchContactListHandler: function (keyWord, wordFlag) {
      this.postRequest('/contactlist/getcontactlist', {
        keyWord: keyWord,
        wordFlag: wordFlag,
        companyID: this.selectedCompanyID,
      })
        .then(e => {
          if (e.session) {
            this.contactList = e.data;
            // #2121
            if (typeof this.contactList === 'undefined') {
              this.contactList = {};
            }
            if (Object.keys(this.contactList).length === 0) {
              this.emptyText = this.messageEmptyText;
            }
            this.setLinkRowForName(wordFlag); // #2121
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('連絡帳一覧取得'));
        });
    },
    /**
     * #2121 有効な行リンクがクリックされた時のハンドラ
     * @param {string} key - クリックされた行リンク(contactSummaryList)のkey項目
     */
    handleSummaryItem(key) {
      let selectedNum = 0;
      for (const contactSummary of this.contactSummaryList) {
        selectedNum++;
        if (contactSummary.key === key) {
          break;
        }
      }
      this.oldWordFlag = String(selectedNum);
      this.fetchContactListHandlerEx(this.searchFilter.replace(/\t/g, '').replace(/[ 　]/g, '_'), this.oldWordFlag);
    },
    // #2121 selectBoxが'name'の場合のリンク行の処理
    // fetchContactListHandler()の内部にあった処理を切り出し
    setLinkRowForName(wordFlag) {
      const fetchedRow = this.contactSummaryList[wordFlag - 1].key;

      this.contactSummaryList.forEach(element => {
        if (element.key === fetchedRow) {
          element.active = false;
          document.getElementById(element.key).style.background = '#fffacd';
        } else {
          element.active = true;
          document.getElementById(element.key).style.background = '#ffffff';
        }
      });

      if (this.searchForm.type === 'name') {
        for (const key in this.contactList) {
          this.contactList[key].sublabel = this.contactList[key].nameKana; // #2285
        }
      }
    },
    /**
     * #2121対応 selectBoxの選択が変更になった場合のハンドラ
     */
    handleChange() {
      // #2285 変更時に検索キーワード入力欄をクリアする
      this.oldWordFlag = '0';
      this.searchFilter = '';
      this.fetchContactListHandlerEx(this.searchFilter, this.oldWordFlag);
    },
    /**
     * #2121 リンク行(あかさたなリンク)のenable/disable設定 TOB
     * #2285 現在の検索集合(this.contactList)からwordFlagで指定された行の集合(this.dispContactList)を
     * 新たに作成しその行に移動する。
     * wordfFlagが'0'の場合には現在の検索集合中の先頭の行に移動する。
     * 現在の検索集合のnameKanaを見て存在する行のみenableにする。
     * 移動した行の行インデックスをthis.oldWordFlagに設定する
     * @param {string} wordFlg - フォーカスを当てる行フラグ '0'の場合は検索集合に存在する最初の行
     */
    setLinkRowDisable(wordFlag) {
      const lineRegexpList = [
        '^[ァ-オ].*',
        '^[カ-ゴヵヶ].*',
        '^[サ-ゾ].*',
        '^[タ-ド].*',
        '^[ナ-ノ].*',
        '^[ハ-ポ].*',
        '^[マ-モ].*',
        '^[ャ-ヨ].*',
        '^[ラ-ロ].*',
        '^[ヮ-ヴヷ-ヺ].*',
        '^[0-z０-９ー].*',
      ];

      this.dispContactList = {};
      for (let i = 0; i < this.contactSummaryList.length; i++) {
        this.contactSummaryList[i].active = false;
        document.getElementById(this.contactSummaryList[i].key).style.background = '#ffffff';
        for (const key in this.contactList) {
          const re = new RegExp(lineRegexpList[i], '');
          if (re.test(this.contactList[key].nameKana)) {
            this.contactSummaryList[i].active = true;
            break;
          }
        }
      }
      // '0' or '' の場合はアクティブな先頭行にフォーカスする
      if (wordFlag === '0' || wordFlag === '') {
        this.oldWordFlag = '0';
        for (let i = 0; i < this.contactSummaryList.length; i++) {
          if (this.contactSummaryList[i].active === true) {
            this.oldWordFlag = String(i + 1);
            break;
          }
        }
      }
      // どこにもフォーカスされなかった(=現在の集合は空集合)
      if (this.oldWordFlag === '0') {
        return;
      }
      const nInx = Number(this.oldWordFlag) - 1;
      // フォーカス行をdisableにしてかつ背景色を変更
      this.contactSummaryList[nInx].active = false;
      document.getElementById(this.contactSummaryList[nInx].key).style.background = '#fffacd';
      // 検索集合から表示する集合(行インデックスの行のみ)を抽出する
      let tmpCounter = 0;
      for (const key in this.contactList) {
        const re = new RegExp(lineRegexpList[nInx], 'm');
        this.contactList[key].sublabel = this.contactList[key][this.searchForm.type];
        if (this.searchForm.type === 'name') {
          // #4685 カナ表示内容修正
          if (typeof this.contactList[key].nameKana !== 'undefined') {
            this.contactList[key].nameKana = this.contactList[key].nameKana.replace('_', ' ');
          }
          this.contactList[key].sublabel = this.contactList[key].nameKana;
        }
        if (re.test(this.contactList[key].nameKana)) {
          this.dispContactList[key] = this.contactList[key];
          this.dispContactList[key].id = 'row_' + String(tmpCounter++);
        }
      }
    },
    /**
     * #2121 現在の検索項目に対してkeyWordで前方一致検索を行う
     * @param {string} keyWord - 前方一致でキーワード検索を行う対象の文字列
     * @param {string} wordFlag - 現在の行インデックス
     */
    fetchContactListHandlerEx: async function (keyWord, wordFlag) {
      await this.postRequest('/contactlist/getcontactlistEx', {
        keyWord: keyWord,
        // #2285 無条件に行インデックスを無視するように変更
        wordFlag: '0',
        // wordFlag: wordFlag ? wordFlag : '0',
        companyID: this.selectedCompanyID,
        itemID: this.searchForm.type,
      })
        .then(e => {
          if (e.session) {
            this.contactList = e.data;
            if (typeof this.contactList === 'undefined') {
              this.contactList = {};
            }
            if (Object.keys(this.contactList).length === 0) {
              this.emptyText = this.messageEmptyText;
            }
            this.setLinkRowDisable(wordFlag);
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('連絡帳一覧取得'));
        });
    },
    handleAddUserClick() {
      if (
        !PERMISSIONS_FRONTEND['phoneDataEditing'][this.authInfo] &&
        !(this.companyID !== POINT && this.authInfo === 'operator')
      ) {
        // 管理者(マスタ含む)かつまたは003300以外の企業のオペレータ以外の場合、新規登録不可
        this.$router.push({ path: '/permission-denied' });
      } else {
        this.postRequest('/contactlist/listcount', { contactID: this.$route.query.contactID })
          .then(e => {
            if (e.session) {
              if (e.msg) {
                this.showErrorModal(e.msg);
              } else {
                this.$router.push({
                  path: '/contactlist/add',
                  query: {
                    wordFlag: this.oldWordFlag,
                    searchFormType: this.searchForm.type,
                    companyID: this.selectedCompanyID,
                  },
                }); // #2121
              }
            } else {
              window.location.href = '/login';
            }
          })
          .catch(err => {
            console.log(err);
            this.showErrorModal(messageContent.requireTry('連絡帳一覧取得'));
          });
      }
    },
    handleItemClick(contactID) {
      this.$router.push({
        path: '/contactlist/detail',
        query: {
          contactID: contactID,
          wordFlag: this.oldWordFlag,
          searchFormType: this.searchForm.type,
          companyID: this.selectedCompanyID,
        },
      }); // #2121
    },
    handleBulkAddUserClick() {
      if ((this.companyID !== POINT && this.authInfo === 'operator') || this.companyID === POINT) {
        // 権限がない(003300以外のオペレータ, または003300)の場合、一括登録不可
        this.$router.push({ path: '/permission-denied' });
      } else {
        this.$router.push({
          path: '/contactlist/upload',
          query: { wordFlag: this.oldWordFlag, searchFormType: this.searchForm.type, csvType: 'ins' },
        });
      }
    },
    handleBulkDelUserClick() {
      this.$router.push({
        path: '/contactlist/upload',
        query: { wordFlag: this.oldWordFlag, searchFormType: this.searchForm.type, csvType: 'del' },
      });
    },
    handleDownloadClick() {
      this.postRequest('/contactlist/download')
        .then(e => {
          const blob = new Blob([e.data], { type: 'text/plain' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.download = 'contactlist.csv';
          a.href = url;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('連絡帳ダウンロード'));
        });
    },
    getUserAuth: async function () {
      await this.postRequest('/contactlist/getuserdata', { companyID: this.companyID })
        .then(e => {
          if (e.session) {
            // 003300 または003300以外のオペレータは一括登録 & 一括ダウンロードを非表示
            if (e.status === 'success' && (this.companyID === POINT || e.udata.authInfo === 'operator')) {
              this.viewBtn = false;
            }
            // 管理者(マスタ含む)または003300以外の企業のオペレータ以外は新規登録を非表示
            if (
              e.status === 'success' &&
              !PERMISSIONS_FRONTEND['phoneDataEditing'][e.udata.authInfo] &&
              !(this.companyID !== POINT && e.udata.authInfo === 'operator')
            ) {
              this.viewAddBtn = false;
            }
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('連絡帳一覧取得'));
        });
    },
  },
};
</script>
